<template>
  <v-card class="ma-4" elevation="0">
    <v-card-title>Mis descargas</v-card-title>
    <v-card-text>
      <v-row class="mb-2">
        <v-col cols="12" md="2">
          <v-btn color="primary" small @click="loadData">
            <v-icon left small>mdi-refresh</v-icon>
            Actualizar lista
          </v-btn>
        </v-col>
      </v-row>
      <iel-table :headers="headers" :loading="loading">
        <tr v-if="jobs.length <= 0">
          <iel-table-cell :cols="5"> No hay descargas </iel-table-cell>
        </tr>
        <tr v-for="job in jobs" :key="`job-${job.id}`">
          <iel-table-cell>{{ typeLabel(job.type) }}</iel-table-cell>
          <iel-table-cell>
            <v-chip :color="statusColor(job.status)" class="ma-1" small dark>
              {{ statusLabel(job.status) }}
            </v-chip>
            <v-tooltip
              v-if="job.status === 'failed' && job.error_message"
              bottom
            >
              <template #activator="{ on }">
                <v-icon small class="ml-1" v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <span>{{ job.error_message }}</span>
            </v-tooltip>
          </iel-table-cell>
          <iel-table-cell>{{ job.created_at }}</iel-table-cell>
          <iel-table-cell>{{ job.updated_at }}</iel-table-cell>
          <iel-table-cell>
            <v-btn
              v-if="job.status === 'completed'"
              small
              color="success"
              @click="doDownload(job.id)"
            >
              <v-icon small left>mdi-download</v-icon>
              Descargar
            </v-btn>
            <span v-else class="text-caption grey--text">—</span>
          </iel-table-cell>
        </tr>
      </iel-table>
      <div v-if="pagination.to > 1" class="text-center my-2">
        <v-pagination
          v-model="currentPage"
          :length="pagination.to"
          @input="onPageChange"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import IelTable from '@/components/tables/IElTable.vue';
  import IelTableCell from '@/components/tables/IELTableCell.vue';
  import saveFile from '@/mixins/saveFile';
  import { mapActions, mapGetters } from 'vuex';

  const TYPE_LABELS = {
    customers_export: 'Exportación de clientes',
  };
  const STATUS_LABELS = {
    pending: 'Pendiente',
    processing: 'Generando',
    completed: 'Completado',
    failed: 'Fallido',
  };
  const STATUS_COLORS = {
    pending: 'grey',
    processing: 'primary',
    completed: 'success',
    failed: 'error',
  };

  export default {
    name: 'DownloadJobs',
    components: { IelTable, IelTableCell },
    mixins: [saveFile],

    data: () => ({
      headers: [
        { text: 'Tipo' },
        { text: 'Estado' },
        { text: 'Fecha solicitud' },
        { text: 'Última actualización' },
        { text: 'Acciones' },
      ],
      loading: false,
    }),

    computed: {
      ...mapGetters('downloadJobs', ['jobs', 'pagination']),
      currentPage: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.loadData(val);
        },
      },
    },

    mounted() {
      this.loadData(1);
    },

    methods: {
      ...mapActions('downloadJobs', ['fetchDownloadJobs', 'downloadFile']),
      ...mapActions('loader', ['activeLoader', 'desactiveLoader']),
      async loadData(page = 1) {
        this.loading = true;
        this.activeLoader();
        try {
          await this.fetchDownloadJobs({
            per_page: 15,
            page,
          });
        } catch (_) {
          this.$toast.error('Error al cargar las descargas');
        } finally {
          this.loading = false;
          this.desactiveLoader();
        }
      },
      onPageChange(page) {
        this.loadData(page);
      },
      typeLabel(type) {
        return TYPE_LABELS[type] || type || '—';
      },
      statusLabel(status) {
        return STATUS_LABELS[status] || status || '—';
      },
      statusColor(status) {
        return STATUS_COLORS[status] || 'grey';
      },
      async doDownload(id) {
        try {
          const { blob, filename } = await this.downloadFile(id);
          const baseName =
            filename.replace(/\.[^.]+$/, '') || 'solicitudes_clientes';
          this.saveFileToDevice(blob, baseName, 'xlsx');
          this.$toast.success('Descarga iniciada');
        } catch (err) {
          const msg =
            err?.response?.data?.message ||
            'El archivo aún no está listo o la exportación falló.';
          this.$toast.error(msg);
        }
      },
    },
  };
</script>
